import { useEffect, type ReactNode } from 'react';
import { setOutboxUser } from '../../lib/offline';
import { ApiError } from '../../lib/api';
import { useMe } from './api';
import LoginPage from './LoginPage';
import ChangePasswordView from './ChangePasswordView';

// Brána aplikace: bez platné session → login, s vynucenou změnou hesla → změna hesla.
export default function AuthGate({ children }: { children: ReactNode }) {
  const { data: user, isLoading, error, refetch } = useMe();
  // Offline fronta patří tomu, kdo akci udělal: na sdíleném tabletu se nesmí odeslat pod jiným jménem.
  useEffect(() => setOutboxUser(user?.id ?? null), [user?.id]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-50 dark:bg-zinc-950">
        <p className="text-sm text-zinc-500">Načítám…</p>
      </div>
    );
  }

  // Přihlášený člověk při výpadku zůstává v práci: chyba obnovení nesmí zahodit rozepsaný
  // formulář. Odhlásí ho jen skutečná 401.
  if ((error as ApiError | null)?.status === 401 || (!user && !error)) return <LoginPage />;

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-50 dark:bg-zinc-950 p-4">
        <div className="text-center">
          <p className="text-sm text-red-600 dark:text-red-400">Server je teď nedostupný.</p>
          <button onClick={() => void refetch()} className="mt-2 text-sm underline">Zkusit znovu</button>
        </div>
      </div>
    );
  }

  if (user.mustChangePassword) return <ChangePasswordView user={user} />;

  return <>{children}</>;
}
